/* unplugin-vue-components disabled */import formatAmount from '@/shared/formatAmount';
export default {
    __name: 'coupon-rules-popup',
    props: {
        value: Boolean,
        couponObj: function() {}
    },
    emits: [
        'close'
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        watch(function() {
            return props.value;
        }, function(val) {
            if (val) {
                console.log('open');
            } else {
                console.log('close');
            }
        });
        var onOpenedPopup = function() {
            console.log('open');
        };
        var onClosedPopup = function() {
            console.log('close');
        };
        return {
            __sfc: true,
            props: props,
            emit: emit,
            onOpenedPopup: onOpenedPopup,
            onClosedPopup: onClosedPopup,
            formatAmount: formatAmount
        };
    }
};
